<template>
  <div>
    <div v-if="loading" class="spinner-container bg-light">
      <div class="spinner"></div>
    </div>

    <div v-else-if="error" class="alert alert-danger text-center">
      {{ error }}
    </div>

    <div v-else>
      <div class="container">
        <h1 v-if="article" class="text-center mb-4 mt-5" style="color: #1e347d; font-weight: bold">
          {{ article.title }}
        </h1>
        <div v-html="$sanitize.sanitizeArticleContent(renderedContent)"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { useArticlesStore } from "@/stores/articlesStore";

  export default {
    components: {},
    data() {
      return {
        article: null,
        renderedContent: `<h1>Page en cours de construction</h1>`,
        articlesStore: null,
        loading: false,
        error: null,
      };
    },
    async created() {
      this.articlesStore = useArticlesStore();
      const slug = this.$route.params.slug;
      if (slug) {
        this.loading = true;
        this.error = null;
        try {
          await this.articlesStore.fetchArticle(slug);
          if (this.articlesStore.currentArticle) {
            this.article = this.articlesStore.currentArticle;
            this.renderedContent = this.article.renderedContent || `<p>Aucun contenu disponible</p>`;
          } else {
            this.error = "Article non trouvé";
          }
        } catch (err) {
          this.error = this.articlesStore.error || "Erreur lors du chargement de l'article";
        } finally {
          this.loading = false;
        }
      } else {
        this.error = "Aucun identifiant d'article fourni";
      }
    },
  };
</script>

<style scoped>
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #ec621a;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
